export default __webpack_public_path__ + "static/inPraiseOfThought-50e8d9b23dccce38efe88ce743107b93.svg";